import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@mui/material';
import React from 'react';
import ProgressBar from '../ProgressBar/ProgressBar';
import TimeLeftInfo from './TimeLeftInfo';
export const GoalProgressNotificationWidget = ({ actual, target, repeat, daysleft, }) => {
    const actualNum = Number(actual);
    const targetNum = Number(target);
    return (_jsxs(_Fragment, { children: [_jsx(ProgressBar, { sx: { gridArea: 'progress' }, max: Math.round(targetNum), current: Math.round(actualNum), starred: actualNum > targetNum, isDollarAmount: true }), repeat && daysleft ? (_jsx(Box, { sx: { mt: 1 }, children: _jsx(TimeLeftInfo, { ndays: Number(daysleft), range: Number(repeat) }) })) : (_jsx(_Fragment, {}))] }));
};
